import React, { Component, createRef } from 'react';
import './style.css';
import ERROR_MESSAGES from './ErrorMessages';

export class PaymentReceipt extends Component {
    constructor(props) {
        super(props);

        const { paymentId } = this.props.match.params;

        this.state = {
            paymentReceiptId: paymentId,
            receipt: null,
            isApiError: null,
            licensePlate: '',
            paymentDetails: null
        };

        this.getPaymentDetails = this.getPaymentDetails.bind(this);
        this.printRef = createRef();
    }

    componentDidMount() {
    }

    handlePrint = () => {
        const printContents = this.printRef.current.innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload(); // To re-render the app after print
    }

    getPaymentDetails() {
        var url = `/api/case/receipt?uniqueIdentifier=${this.state.paymentReceiptId}&licensePlate=${this.state.licensePlate}`;
        const requestOptions =
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }

        this.setState({ isLoading: true });

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(apiData => {
                if (apiData.ResponseStatus === 200) {
                    this.setState({ apiResponse: apiData });
                    this.setState({ paymentDetails: apiData })
                }
                else {
                    this.setState({ isApiError: true });
                    this.setState({ paymentDetails: null })
                }

                console.log(apiData)
                console.log(this.state);
            })
            .catch((err) => {
                this.setState({ isApiError: true });
            });
    }

    formatCurrency(value) {
        return new Intl.NumberFormat('en-IE', {
            style: 'currency',
            currency: 'EUR',
        }).format(value);
    };

    render() {
        if (this.state.paymentDetails != null && !this.state.isApiError) {
            return (
                <div>
                    <div ref={this.printRef} className="card p-4 shadow-sm">
                        <h2 className="mb-3">Payment Receipt</h2>
                        <h3>eFlow M50 Payment to Pierse Fitzgibbon Solicitors LLP</h3>
                        <p><strong>Payment Reference:</strong> {this.state.paymentDetails.PaymentID}</p>
                        <p><strong>Amount:</strong> {this.formatCurrency(this.state.paymentDetails.Amount)}</p>
                        <p><strong>Date:</strong> {new Date(this.state.paymentDetails.PaymentDate).toLocaleDateString()}</p>
                    </div>
                    <button className="btn btn-secondary mt-3" onClick={this.handlePrint}>
                        Print Receipt
                    </button>
                </div>


            )
        }
        else if (this.state.paymentDetails == null && this.state.isApiError) {
            return (
                <div className="card p-4 shadow-sm">
                    <h2 className="mb-3">There was an error getting your payment</h2>
                </div>
            )
        }
        else if (this.state.paymentDetails == null && !this.state.isApiError) {
            return (
                <div className="container">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter License Plate"
                            value={this.state.licensePlate}
                            onChange={(e) => this.setState({ licensePlate: e.target.value })}
                            disabled={this.state.isLoading}
                        />
                    </div>
                    <button
                        className="btn btn-primary w-100"
                        onClick={this.getPaymentDetails}
                        disabled={this.state.isLoading}
                    >
                        Get Payment Details
                    </button>

                    {this.state.isLoading && (
                        <div className="d-flex justify-content-center mt-3">
                            <div className="spinner-border text-primary" role="status">
                            </div>
                        </div>
                    )}
                </div>
            )
        }
        else {
            return (
                <div className="alert alert-danger" role="alert">
                    {ERROR_MESSAGES.GENERIC_ERROR}
                </div>
            );
        }
    }
}
